import { useEffect, useState } from 'react';
import { termsAPI } from '../api';
import { TermsModal } from '../components';
import { getErrorMessage } from '@/api/unwrapQuery';

/**
 * After-login terms acceptance gate.
 *
 * Checks the authenticated user's terms status on mount. If they accepted an
 * older version (or none) of the currently active terms, shows the
 * scroll-to-accept modal and records acceptance on approve.
 */
export const TermsGate = () => {
    const [needsAcceptance, setNeedsAcceptance] = useState(false);
    const [terms, setTerms] = useState(null);
    const [loading, setLoading] = useState(true);
    const [accepting, setAccepting] = useState(false);
    const [error, setError] = useState(null);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const status = await termsAPI.getStatus();
                if (cancelled) return;
                if (status?.success && status.data?.needsAcceptance) {
                    setNeedsAcceptance(true);
                    const active = await termsAPI.getActive();
                    if (cancelled) return;
                    if (active?.success) {
                        setTerms(active.data);
                    } else {
                        setError(active?.message || 'خطا در دریافت قوانین');
                    }
                }
            } catch (err) {
                if (!cancelled) setError(getErrorMessage(err, 'خطا در دریافت وضعیت قوانین'));
            } finally {
                if (!cancelled) {
                    setLoading(false);
                    setChecking(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const handleApprove = async () => {
        setAccepting(true);
        setError(null);
        try {
            const response = await termsAPI.accept(terms?.id);
            if (response?.success) {
                setNeedsAcceptance(false);
                return true;
            }
            setError(response?.message || 'خطا در ثبت پذیرش قوانین');
            return false;
        } catch (err) {
            setError(getErrorMessage(err, 'خطا در ثبت پذیرش قوانین'));
            return false;
        } finally {
            setAccepting(false);
        }
    };

    if (checking || loading) {
        return null;
    }

    if (!needsAcceptance) {
        return null;
    }

    return (
        <TermsModal
            isOpen={needsAcceptance}
            onClose={() => { }}
            terms={terms}
            error={error}
            approving={accepting}
            onApprove={handleApprove}
            approveText="تایید قوانین جدید"
        />
    );
};

export default TermsGate;